export enum SessionResultStatus {
    Success = 'success',
    Failed = 'failed'
}
